import { render, staticRenderFns } from "./AnnouncementPanelContent.vue?vue&type=template&id=091f3870&scoped=true&"
import script from "./AnnouncementPanelContent.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementPanelContent.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementPanelContent.vue?vue&type=style&index=0&id=091f3870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091f3870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
